/**
 * N.2 — Onay Bekleyenler
 * Onaylayan olarak atanan kullanıcının onaylaması gereken notlar
 */
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import RichEditor from '../components/RichEditor';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const tkn = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const SABIT_ALANLAR = [
  { key: 'birim',             label: 'Birim' },
  { key: 'konu',              label: 'Konu' },
  { key: 'sunulan_makam',     label: 'Sunulan Makam' },
  { key: 'hazirlayan',        label: 'Hazırlayan' },
  { key: 'tarih',             label: 'Bilgi Notu Tarihi' },
  { key: 'yonetici_ozeti',    label: 'Yönetici Özeti' },
  { key: 'ana_metin',         label: 'Ana Metin' },
  { key: 'istatistiki_bilgi', label: 'İstatistiki Bilgiler' },
  { key: 'sonuc',             label: 'Sonuç ve Değerlendirme' },
];

const RICHTEXT_KEYS = new Set(['yonetici_ozeti', 'ana_metin', 'istatistiki_bilgi', 'sonuc']);

export default function BilgiNotOnay() {
  const [notlar, setNotlar] = useState<any[]>([]);
  const [secili, setSecili] = useState<any>(null);
  const [akis, setAkis] = useState<any[]>([]);
  const [redNedeni, setRedNedeni] = useState('');
  const [redModal, setRedModal] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');

  const yukle = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/api/bilgi-notu/`, { headers: tkn(), params: { goruntule: 'onay' } });
      setNotlar(r.data);
    } catch { setNotlar([]); }
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const detayAc = async (n: any) => {
    setSecili(n);
    setHata(''); setMesaj(''); setRedNedeni(''); setRedModal(false);
    try {
      const r = await axios.get(`${API}/api/bilgi-notu/${n.id}/akis`, { headers: tkn() });
      setAkis(r.data);
    } catch { setAkis([]); }
  };

  const onayla = async () => {
    if (!secili) return;
    setYukleniyor(true); setHata('');
    try {
      await axios.post(`${API}/api/bilgi-notu/${secili.id}/onayla`, {}, { headers: tkn() });
      setMesaj('✅ Not onaylandı'); yukle(); setSecili(null);
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Hata');
    } finally { setYukleniyor(false); }
  };

  const reddet = async () => {
    if (!redNedeni.trim()) { setHata('Red nedeni giriniz'); return; }
    setYukleniyor(true); setHata('');
    try {
      await axios.post(`${API}/api/bilgi-notu/${secili.id}/reddet`, { red_nedeni: redNedeni }, { headers: tkn() });
      setMesaj('❌ Not reddedildi'); setRedModal(false); yukle(); setSecili(null);
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Hata');
    } finally { setYukleniyor(false); }
  };

  if (secili) return (
    <div style={{ padding: 24, maxWidth: 860, margin: '0 auto' }}>
      <button onClick={() => setSecili(null)}
        style={{ background: 'none', border: 'none', color: '#1a4a7a', cursor: 'pointer', fontSize: 14, marginBottom: 12 }}>
        ← Listeye Dön
      </button>
      <h2 style={{ color: '#1a4a7a', marginBottom: 4 }}>Bilgi Notu İnceleme</h2>
      <div style={{ color: '#666', fontSize: 13, marginBottom: 20 }}>
        Hazırlayan: <strong>{secili.hazirlayan_ad}</strong> • {secili.hazirlayan_birim}
        {' '} • {secili.olusturma_tarihi?.slice(0, 10)}
      </div>

      {hata && <div style={{ background: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: 6, marginBottom: 16 }}>{hata}</div>}
      {mesaj && <div style={{ background: '#eafaf1', color: '#1e8449', padding: '10px 14px', borderRadius: 6, marginBottom: 16 }}>{mesaj}</div>}

      {/* Bilgi notu içeriği */}
      <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', marginBottom: 24 }}>
        <div style={{ background: '#1a4a7a', color: '#fff', padding: '12px 20px', fontWeight: 600 }}>
          📄 Bilgi Notu İçeriği
        </div>
        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 20 }}>
          {SABIT_ALANLAR.filter(a => secili.alanlar?.[a.key]).map(alan => (
            <div key={alan.key}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#777', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 }}>
                {alan.label}
              </div>
              {RICHTEXT_KEYS.has(alan.key) ? (
                <RichEditor value={secili.alanlar[alan.key]} onChange={() => {}} disabled />
              ) : (
                <div style={{ fontSize: 15, color: '#222', lineHeight: 1.5 }}>{secili.alanlar[alan.key]}</div>
              )}
            </div>
          ))}
          {secili.etiketler?.length > 0 && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#777', marginBottom: 6 }}>ETİKETLER</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {secili.etiketler.map((e: string) => (
                  <span key={e} style={{ background: '#e8f0fe', color: '#1a4a7a', padding: '2px 10px', borderRadius: 12, fontSize: 12 }}>{e}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* İşlem geçmişi */}
      {akis.length > 0 && (
        <div style={{ marginBottom: 24, background: '#f8f9fa', borderRadius: 8, padding: 16, border: '1px solid #e0e0e0' }}>
          <div style={{ fontWeight: 600, marginBottom: 10, color: '#555' }}>İşlem Geçmişi</div>
          {akis.map((a: any, i: number) => (
            <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 6, fontSize: 13 }}>
              <span style={{ color: '#999', minWidth: 130 }}>{a.tarih?.slice(0, 16).replace('T', ' ')}</span>
              <span style={{ fontWeight: 500 }}>{a.yapan_ad}</span>
              <span style={{ color: '#666 ' }}>— {a.islem.replace(/_/g, ' ')}</span>
              {a.aciklama && <span style={{ color: '#e74c3c' }}>({a.aciklama})</span>}
            </div>
          ))}
        </div>
      )}

      {/* Aksiyon butonları */}
      <div style={{ display: 'flex', gap: 12 }}>
        <button onClick={() => setSecili(null)}
          style={{ padding: '10px 24px', border: '1px solid #ddd', borderRadius: 6, background: '#f5f5f5', cursor: 'pointer', fontSize: 14 }}>
          Geri
        </button>
        <button onClick={() => setRedModal(true)} disabled={yukleniyor}
          style={{ padding: '10px 24px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          ❌ Reddet
        </button>
        <button onClick={onayla} disabled={yukleniyor}
          style={{ padding: '10px 24px', background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          {yukleniyor ? 'İşleniyor...' : '✅ Onayla'}
        </button>
      </div>

      {/* Red modal */}
      {redModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 10, padding: 28, width: 440, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <h3 style={{ margin: '0 0 16px', color: '#c0392b' }}>❌ Reddetme Nedeni</h3>
            <textarea value={redNedeni} onChange={e => setRedNedeni(e.target.value)}
              placeholder="Notu reddetme nedeninizi açıklayın..."
              rows={4}
              style={{ width: '100%', padding: '10px 12px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }} />
            {hata && <div style={{ color: '#c0392b', fontSize: 13, marginTop: 6 }}>{hata}</div>}
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button onClick={() => { setRedModal(false); setHata(''); }}
                style={{ flex: 1, padding: '10px', border: '1px solid #ddd', borderRadius: 6, background: '#f5f5f5', cursor: 'pointer' }}>
                İptal
              </button>
              <button onClick={reddet} disabled={yukleniyor}
                style={{ flex: 2, padding: '10px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
                {yukleniyor ? 'İşleniyor...' : 'Reddet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // ── Liste ───────────────────────────────────────────────────
  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <h2 style={{ color: '#1a4a7a', marginBottom: 16 }}>⏳ Onay Bekleyen Notlar</h2>

      {mesaj && <div style={{ background: '#eafaf1', color: '#1e8449', padding: '10px 14px', borderRadius: 6, marginBottom: 16 }}>{mesaj}</div>}

      {notlar.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#aaa', padding: 60, fontSize: 15 }}>
          Onayınızı bekleyen not bulunmamaktadır.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <thead>
            <tr style={{ background: '#f0f4f8', borderBottom: '2px solid #ddd' }}>
              {['Konu', 'Hazırlayan', 'Birim', 'Gönderilme Tarihi', 'İşlem'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#444' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {notlar.map(n => (
              <tr key={n.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px 12px', fontWeight: 500 }}>{n.alanlar?.konu || '—'}</td>
                <td style={{ padding: '10px 12px', color: '#555' }}>{n.hazirlayan_ad}</td>
                <td style={{ padding: '10px 12px', color: '#666' }}>{n.hazirlayan_birim || '—'}</td>
                <td style={{ padding: '10px 12px', color: '#666', whiteSpace: 'nowrap' }}>
                  {n.guncelleme_tarihi?.slice(0, 16).replace('T', ' ') || n.olusturma_tarihi?.slice(0, 16).replace('T', ' ')}
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <button onClick={() => detayAc(n)}
                    style={{ background: '#1a4a7a', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 14px', cursor: 'pointer', fontSize: 13 }}>
                    İncele
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
